export const colors = {
  primary: '#1DBAB4',
  primary5: 'rgba(127, 235, 231, 0.50)',
  primary10: '#7FEBE7',
  primary10WithOpacity80: '#7FEBE780',
  primary20: '#5BE5E1',
  primary30: '#36E0DA',
  primary40: '#20CCC6',
  primary60: '#1BACA7',
  primary70: '#17928D',
  primary80: '#137774',
  primary90: '#0E5D5A',
  secondary: '#F29551',
  secondary5: 'rgba(248, 201, 167, 0.50)',
  secondary10: '#F8C9A7',
  secondary20: '#F6B282',
  secondary30: '#F5AA75',
  secondary40: '#F39B5C',
  secondary60: '#E6955B',
  secondary70: '#E09661',
  secondary80: '#D5986C',
  secondary90: '#C99A78',
  tertiary: '#82BC58',
  tertiary5: 'rgba(192, 222, 171, 0.50)',
  tertiary10: '#C0DEAB',
  tertiary20: '#AED493',
  tertiary30: '#9CCA7B',
  tertiary40: '#8AC163',
  tertiary60: '#77B749',
  tertiary70: '#649B3E',
  tertiary80: '#527F32',
  tertiary90: '#406227',
};

export const alertColors = {
  danger: '#DE1E1E',
  info: '#2B6CEE',
  success: '#37B24D',
  warning: '#DE7A16',
};

export const backgrounds = {
  bg1: '#DBDBDB',
  bg2: '#E8EDED',
  bg3: '#F6F8F8',
  bg4: '#FFFFFF',
  bg4WithOpacity50: 'rgba(255, 255, 255, 0.50)',
  bg5: '#32523F',
};

export const texts = {
  text1: '#1A2021',
  text2: '#535859',
  text3: '#989B9B',
  text4: '#F6F8F8',
  text5: '#FFFFFF',
};

export const fonts = {
  IBMPlexSansBold: 'IBMPlexSans-Bold',
  IBMPlexSansMedium: 'IBMPlexSans-Medium',
  IBMPlexSansRegular: 'IBMPlexSans-Regular',
  IBMPlexSansSemiBold: 'IBMPlexSans-SemiBold',
};

export const boxShadow = {
  100: '0px 4px 8px -4px rgba(23, 23, 23, 0.25)',
  200: '0px 8px 12px -4px rgba(23, 23, 23, 0.25)',
  300: '0px 8px 12px -4px rgba(23, 23, 23, 0.25)',
  down: '0px -1px 0px 0px #E8EDED inset',
  up: '0px 1px 0px 0px #E8EDED inset',
  right: '-1px 0px 0px 0px #E8EDED inset',
  left: '1px 0px 0px 0px #E8EDED inset',
};

export const gradients = {
  gradient1: 'linear-gradient(180deg, rgba(222,242,237,0) 0%, rgba(222,242,237,1) 100%)',
  gradient2: 'linear-gradient(180deg, rgba(27,172,167,1) 0%, rgba(23,207,201,0.88) 65%)',
};
